module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OTYuMDczIDQzOC42MzIiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJQYXRoXzIyIiBkYXRhLW5hbWU9IlBhdGggMjIiIGNsYXNzPSJjbHMtMSIgZD0iTS04ODgsNjAxdjQzOC42MzJoNTk2LjA3M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg4OCAtNjAxKSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./assets/img/corner.svg
// module id = 9
// module chunks = 0